module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "drop"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "top-tip",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hide($event)
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ccad3a3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/top-tip/top-tip.vue
// module id = 536
// module chunks = 9